export default __webpack_public_path__ + "static/media/saxenda.8c349c68.png";